import { Layout } from '@/shared/ui/layout'
import { FC } from 'react'

const NotFound: FC = () => {
	return <Layout position='center' title='Not Found' />
}

export default NotFound
